import { TVariant } from '.'

export const dict: Record<
  TVariant,
  {
    closeLabel: 'cancel' | 'close' | 'get_started'
    submitLabel: 'save' | 'publish' | undefined
  }
> = {
  edit: {
    closeLabel: 'cancel',
    submitLabel: 'save'
  },
  info: {
    closeLabel: 'close',
    submitLabel: undefined
  },
  publish: {
    closeLabel: 'close',
    submitLabel: 'publish'
  },
  welcome: {
    closeLabel: 'get_started',
    submitLabel: undefined
  }
}
